import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M6.774 9.845a2.58 2.58 0 0 0-.76 1.835c0 .436.106.855.307 1.229l4.88-4.88 1.349 1.35V5.346l-4.031.001 1.377 1.377-3.122 3.121z" />
    <path d="M0 0v18h18V0H0zm14.05 12.999l-2.849-2.85-4.957 4.957-.53-.53a4.07 4.07 0 0 1-1.2-2.896c0-1.094.426-2.122 1.2-2.896l2.061-2.061-2.878-2.876 9.152-.001v9.153z" />
  </svg>
);

export default SvgComponent;
